import api from './api'
import authHeader from './auth-header';

class AvailabilityService {
    async get(accountUuid, params = {}) {
        return api.get('/account/' + accountUuid + '/availability', {'params': params}, authHeader()).then(response => response.data);
    }
}

export default new AvailabilityService();
